/* eslint-disable react/no-unused-state */
import React, { PureComponent } from 'react';
import { arrayOf, node, string } from 'prop-types';
import qs from 'qs';
import { createBrowserHistory } from 'history';
import { pathToRegexp } from 'path-to-regexp';
import { locationShape } from 'shapes';
import { extractExtraParams } from 'utils';
import { Provider } from './BrowserHistoryContext';

class BrowserHistoryProvider extends PureComponent {
    static propTypes = {
        location: locationShape, // eslint-disable-line react/no-unused-prop-types
        paths: arrayOf(string),
        children: node.isRequired,
    };

    static defaultProps = {
        paths: [],
        location: undefined,
    };

    constructor(props) {
        super(props);

        let location;
        if (typeof window === 'undefined') {
            location = {
                ...props?.location,
                params: this.getParams(null, props?.location),
            };
            this.state = {
                location,
                ...extractExtraParams(location),
            };
            return;
        }

        this.history = createBrowserHistory();

        if (
            !this.history?.location ||
            this.history?.location?.pathname.includes('/recherche/')
        ) {
            this.originalLocation = '/';
        } else {
            this.originalLocation = this.history?.location;
        }

        location = {
            ...this.history?.location,
            params: this.getParams(null, location),
        };

        this.state = {
            location,
            ...extractExtraParams(location),
        };
    }

    componentDidMount() {
        this.unlisten = this.history.listen((location, action) => {
            const searchParams = extractExtraParams(location);
            this.setState({
                location: {
                    ...location,
                    search: location?.search,
                    params: this.getParams(null, location),
                    fromBrowserBack: action === 'POP',
                },
                ...searchParams,
            });
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    getParams = (param, location) => {
        const _location = location || this.history?.location;
        const keys = [];
        const re = pathToRegexp(this.props.paths, keys);
        const pathResult = re.exec(_location?.pathname);
        const index = keys.findIndex(key => key.name === param);
        return (
            pathResult &&
            ((index > -1 && pathResult[index + 1].replace(/\+/g, ' ')) ||
                keys.reduce((result, key, idx) => {
                    if (pathResult[idx + 1]) {
                        return {
                            ...result,
                            [key.name]: pathResult[idx + 1].replace(/\+/g, ' '),
                        };
                    }
                    return result;
                }, {}))
        );
    };

    push = params => {
        if (
            typeof params === 'object' &&
            ((params.pathname &&
                this.history?.location?.pathname !== params.pathname) ||
                this.history?.location?.search !== params.search)
        ) {
            const searchObj = qs.parse(params.search, {
                ignoreQueryPrefix: true,
            });
            const pathname = this.history.location.pathname.replace(
                /\/filter/g,
                '',
            );
            const isFilter = Object.keys(searchObj).some(
                filter => filter !== 'sort' && filter !== 'page',
            );
            const historyPathname = isFilter ? `/filter${pathname}` : pathname;

            this.history.push({
                pathname: historyPathname,
                state: params.state || this.history?.location?.state,
                search:
                    params.search === undefined || params.search === null
                        ? this.history?.location?.search
                        : params.search,
            });
        } else if (
            typeof params === 'string' &&
            this.history?.location?.pathname !== params
        ) {
            this.history.push(params);
        }
    };

    reset = () => {
        if (this.history?.location?.pathname !== this.originalLocation) {
            this.history.push(this.originalLocation);
        }
    };

    /* eslint-enable react/no-unused-state */
    render() {
        return (
            <Provider
                value={{
                    state: this.state,
                    actions: {
                        pushHistory: this.push,
                        resetHistory: this.reset,
                    },
                }}
            >
                {this.props.children}
            </Provider>
        );
    }
}

export default BrowserHistoryProvider;
